import { ChecklistStatus } from '../../demo/ComponentStatus/ComponentStatus.types';

export const SwatchColorPickerStatus = {
  keyboardAccessibilitySupport: ChecklistStatus.unknown,
  markupSupport: ChecklistStatus.unknown,
  highContrastSupport: ChecklistStatus.pass,
  rtlSupport: ChecklistStatus.fail,
  testCoverage: ChecklistStatus.fair
};